<script setup lang="ts">
import { IInstitutionConfiguration } from '@shared/types/base'
import { ref, computed } from 'vue'
import ConfigView from './ConfigView.vue'
import { CConfiguration } from '@/constants/CConfiguration'

const props = defineProps<{
	configuration: IInstitutionConfiguration
	configurationTest: IInstitutionConfiguration
}>()

const configuration = ref<IInstitutionConfiguration>(props.configuration || CConfiguration)

const hasTestModeConfig = computed(() => Object.keys(props.configurationTest).length > 0)

// Validaciones para evitar errores cuando las propiedades no existen
const hasCertificatesConfig = computed(() => Boolean(configuration.value?.certificates))
const hasDegreeConfig = computed(() => Boolean(configuration.value?.degree))
const hasAnyConfig = computed(() => hasCertificatesConfig.value || hasDegreeConfig.value || hasTestModeConfig.value)
</script>

<template>
	<div class="configuration-container">
		<!-- Header -->
		<div class="configuration-header">
			<VaIcon name="settings" size="large" color="#FFFFFF" />
			<h1 class="configuration-title">Configuración de la Institución</h1>
		</div>

		<!-- Modo Visualización -->
		<div>
			<!-- Configuración Normal -->
			<div>
				<ConfigView :has-certificates-config="hasCertificatesConfig" :has-degree-config="hasDegreeConfig" :configuration="configuration" :test-mode="false" />
				<ConfigView v-if="hasTestModeConfig" :has-certificates-config="false" :has-degree-config="true" :configuration="configurationTest" :test-mode="true" />
				<!-- Mensaje si no hay configuración -->
				<VaCard v-if="!hasAnyConfig" class="no-config" elevation="2">
					<VaCardContent class="no-config-content">
						<VaIcon name="info" size="large" color="warning" />
						<h2>No hay configuración disponible</h2>
						<p>La institución no tiene configuración definida para certificados o títulos.</p>
					</VaCardContent>
				</VaCard>
			</div>
		</div>
	</div>
</template>

<style scoped>
.configuration-container {
	padding: 1rem;
	margin: 0 auto;
	max-height: 70vh;
	overflow-y: auto;
	padding-right: 8px;
}

.configuration-header {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;
	margin-bottom: 2rem;
	padding: 1rem;
	background: linear-gradient(135deg, #062342 0%, #062342 100%);
	border-radius: 12px;
	color: white;
}

.configuration-title {
	margin: 0;
	font-size: 1.8rem;
	font-weight: 600;
}

.no-config {
	border-radius: 12px;
}

.no-config-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	padding: 3rem 2rem;
	gap: 1rem;
}

.no-config-content h2 {
	margin: 0;
	color: #6c757d;
	font-size: 1.5rem;
}

.no-config-content p {
	margin: 0;
	color: #868e96;
	font-size: 1rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
	.configuration-container {
		padding: 0.5rem;
	}

	.configuration-header {
		flex-direction: column;
		align-items: flex-start;
		gap: 1rem;
	}
}
</style>
